import { render } from "./EmailCard.vue?vue&type=template&id=72c65898&scoped=true"
import script from "./EmailCard.vue?vue&type=script&lang=js"
export * from "./EmailCard.vue?vue&type=script&lang=js"

import "./EmailCard.vue?vue&type=style&index=0&id=72c65898&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c65898"]])

export default __exports__